import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { InputModel } from './models/input.model';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [
    CommonModule,
    MatFormField,
    MatLabel,
    MatInputModule,
    MatIconModule,
    MatIconButton,
    FormsModule,
  ],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent {
  @Input() options: InputModel = {};

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  onValueChange(newValue: string): void {
    this.options.value = newValue;
    this.valueChange.emit(newValue);
  }

  clearAll(): void {
    this.options.value = '';
    this.onValueChange('');
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();

    const target = event.target as HTMLInputElement;
    const allInputs = Array.from(
      document.querySelectorAll('input[matInput]:not([disabled])'),
    ) as HTMLInputElement[];

    const currentIndex = allInputs.indexOf(target);

    if (currentIndex > -1 && currentIndex < allInputs.length - 1) {
      allInputs[currentIndex + 1].focus();
    }
  }
}
